import React from 'react';

interface LoaderProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    text?: string;
    color?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 'md', className = '', text, color }) => {
    const sizeClasses = {
        sm: 'w-6 h-6 border-2',
        md: 'w-10 h-10 border-4',
        lg: 'w-16 h-16 border-4',
    };

    // Use inline style for custom color, fallback to primary class
    const borderStyle = color ? { borderColor: color, borderTopColor: 'transparent' } : undefined;
    const borderClass = color ? '' : 'border-primary';

    return (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <div
                className={`${sizeClasses[size]} ${borderClass} border-t-transparent rounded-full animate-spin`}
                style={borderStyle}
                role="status"
            >
                <span className="sr-only">Cargando...</span>
            </div>
            {text && <p className="mt-2 text-text-secondary">{text}</p>}
        </div>
    );
};

export default Loader;
